import { ToolCallComplete } from "../../streaming/anthropic-stream-handler.types";
import {
  Message,
  ToolContentBlock,
} from "../../streaming/streaming-message-types";
import { ConversationProvider } from "../provider";
import { ToolExecutionContext, ToolRegistry } from "../tools/registry";

export type StreamProvider = (
  params:
    | { kind: "user"; userText: string; history: Message[] }
    | {
        kind: "tool_results";
        toolResultContent: ToolContentBlock[];
        history: Message[];
      }
) => Promise<Response>;

export class ComposableProvider implements ConversationProvider {
  constructor(
    private readonly streamProvider: StreamProvider,
    private readonly tools: ToolRegistry,
    private readonly toolContext: ToolExecutionContext = {}
  ) {}

  async createUserStream(
    userText: string,
    history: Message[]
  ): Promise<Response> {
    return this.streamProvider({ kind: "user", userText, history });
  }

  async continueWithToolResults(
    toolResultContent: ToolContentBlock[],
    history: Message[]
  ): Promise<Response> {
    return this.streamProvider({
      kind: "tool_results",
      toolResultContent,
      history,
    });
  }

  async executeTool(toolCall: ToolCallComplete): Promise<string> {
    const exec = this.tools.getExecutor(toolCall.name);
    if (!exec) throw new Error(`Unknown tool: ${toolCall.name}`);
    return exec(toolCall.arguments, this.toolContext);
  }
}
